import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzSwitchComponent } from 'ng-zorro-antd/switch';
import { NzIconDirective } from 'ng-zorro-antd/icon';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { NzTooltipDirective } from 'ng-zorro-antd/tooltip';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'twaice-fe-mail-notification-toggle',
  templateUrl: './mail-notification-toggle.component.html',
  styleUrl: './mail-notification-toggle.component.scss',
  providers: [],
  imports: [CommonModule, NzSwitchComponent, NzIconDirective, SvgIconModule, NzTooltipDirective, FormsModule],
})
export class MailNotificationToggleComponent {
  @Input() mailEnabled: boolean | undefined = undefined;
  @Input() mailStatusLoading = false;
  @Input() tooltipSuffix = '';

  @Output() desiredMailEnabledStateChanged = new EventEmitter<boolean>();

  mailNotificationClicked() {
    this.desiredMailEnabledStateChanged.emit(!this.mailEnabled);
  }
}
